import { render, staticRenderFns } from "./TheCard.vue?vue&type=template&id=f224b7be&scoped=true&"
import script from "./TheCard.vue?vue&type=script&lang=js&"
export * from "./TheCard.vue?vue&type=script&lang=js&"
import style0 from "./TheCard.vue?vue&type=style&index=0&id=f224b7be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f224b7be",
  null
  
)

export default component.exports